import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import { ScrollReveal } from '@/components/ScrollReveal';
import { Scale, Shield, Mail, Phone, MapPin, FileText, Cookie, Users } from 'lucide-react';

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      
      {/* Hero Section */}
      <section className="bg-slate-900 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <Scale className="h-8 w-8" />
          </div>
          <h1 className="text-3xl lg:text-5xl font-bold mb-6">
            Mentions Légales
          </h1>
          <p className="text-lg lg:text-xl text-white/90 leading-relaxed max-w-3xl mx-auto">
            Informations légales et conditions d'utilisation du site Les Hirondelles
          </p>
        </div>
      </section>

      {/* Contenu des mentions légales */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* 1. Informations sur l'entreprise */}
          <ScrollReveal>
            <div className="mb-12">
              <div className="flex items-center mb-6">
                <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                  <FileText className="h-5 w-5 text-primary" />
                </div>
                <h2 className="text-2xl font-bold text-slate-900">
                  1. Informations sur l'entreprise
                </h2>
              </div>
              
              <div className="bg-slate-50 rounded-lg p-6 space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <h3 className="font-semibold text-slate-900 mb-2">Dénomination sociale</h3>
                    <p className="text-slate-700">SARL LAUDARE</p>
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-900 mb-2">Forme juridique</h3>
                    <p className="text-slate-700">SARL (Société à Responsabilité Limitée)</p>
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-900 mb-2">Siège social</h3>
                    <div className="flex items-start">
                      <MapPin className="h-4 w-4 text-slate-500 mr-2 mt-1 flex-shrink-0" />
                      <p className="text-slate-700">30 rue Gambetta<br />17590 Ars-en-Ré<br />France</p>
                    </div>
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-900 mb-2">Contact</h3>
                    <div className="space-y-2">
                      <div className="flex items-center">
                        <Phone className="h-4 w-4 text-slate-500 mr-2" />
                        <p className="text-slate-700">07 66 47 77 46</p>
                      </div>
                      <div className="flex items-center">
                        <Mail className="h-4 w-4 text-slate-500 mr-2" />
                        <a href="mailto:laudare.iledere@gmail.com" className="text-primary hover:text-primary/80">
                          laudare.iledere@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ScrollReveal>

          {/* 2. Directeur de la publication */}
          <ScrollReveal>
            <div className="mb-12">
              <div className="flex items-center mb-6">
                <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                  <Users className="h-5 w-5 text-primary" />
                </div>
                <h2 className="text-2xl font-bold text-slate-900">
                  2. Directeur de la publication
                </h2>
              </div>
              
              <div className="bg-slate-50 rounded-lg p-6">
                <p className="text-slate-700">
                  <strong>Directeur de la publication :</strong> SARL LAUDARE<br />
                  <strong>Nom du site web :</strong> Les Hirondelles - Location de vélos pour campings & professionnels
                </p>
              </div>
            </div>
          </ScrollReveal>

          {/* 3. Hébergement */}
          <ScrollReveal>
            <div className="mb-12">
              <div className="flex items-center mb-6">
                <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                  <Shield className="h-5 w-5 text-primary" />
                </div>
                <h2 className="text-2xl font-bold text-slate-900">
                  3. Hébergement
                </h2>
              </div>
              
              <div className="bg-slate-50 rounded-lg p-6">
                <p className="text-slate-700">
                  Ce site est hébergé par des services d'hébergement web professionnels. 
                  Pour toute question relative à l'hébergement, veuillez nous contacter directement.
                </p>
              </div>
            </div>
          </ScrollReveal>

          {/* 4. Propriété intellectuelle */}
          <ScrollReveal>
            <div className="mb-12">
              <div className="flex items-center mb-6">
                <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                  <FileText className="h-5 w-5 text-primary" />
                </div>
                <h2 className="text-2xl font-bold text-slate-900">
                  4. Propriété intellectuelle
                </h2>
              </div>
              
              <div className="bg-slate-50 rounded-lg p-6 space-y-4">
                <p className="text-slate-700">
                  L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. 
                  Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
                </p>
                <p className="text-slate-700">
                  La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est formellement interdite 
                  sauf autorisation expresse du directeur de la publication.
                </p>
                <p className="text-slate-700">
                  Les marques et logos figurant sur le site sont déposés par SARL LAUDARE ou éventuellement par ses partenaires. 
                  Toute reproduction totale ou partielle de ces marques ou logos effectuée à partir des éléments du site sans l'autorisation 
                  expresse de SARL LAUDARE est donc prohibée.
                </p>
              </div>
            </div>
          </ScrollReveal>

          {/* 5. Limitation de responsabilité */}
          <ScrollReveal>
            <div className="mb-12">
              <div className="flex items-center mb-6">
                <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                  <Shield className="h-5 w-5 text-primary" />
                </div>
                <h2 className="text-2xl font-bold text-slate-900">
                  5. Limitation de responsabilité
                </h2>
              </div>
              
              <div className="bg-slate-50 rounded-lg p-6 space-y-4">
                <p className="text-slate-700">
                  Les informations contenues sur ce site sont aussi précises que possible et le site remis à jour à différentes périodes de l'année, 
                  mais peut toutefois contenir des inexactitudes ou des omissions.
                </p>
                <p className="text-slate-700">
                  Si vous constatez une lacune, erreur ou ce qui parait être un dysfonctionnement, merci de bien vouloir le signaler par email, 
                  à l'adresse <a href="mailto:laudare.iledere@gmail.com" className="text-primary hover:text-primary/80">laudare.iledere@gmail.com</a>, 
                  en décrivant le problème de la manière la plus précise possible.
                </p>
                <p className="text-slate-700">
                  SARL LAUDARE ne pourra en aucun cas être tenue responsable de tout dommage de quelque nature qu'il soit résultant de 
                  l'interprétation ou de l'utilisation des informations et/ou documents disponibles sur ce site.
                </p>
              </div>
            </div>
          </ScrollReveal>

          {/* 6. Protection des données personnelles (RGPD) */}
          <ScrollReveal>
            <div className="mb-12">
              <div className="flex items-center mb-6">
                <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                  <Shield className="h-5 w-5 text-primary" />
                </div>
                <h2 className="text-2xl font-bold text-slate-900">
                  6. Protection des données personnelles (RGPD)
                </h2>
              </div>
              
              <div className="bg-slate-50 rounded-lg p-6 space-y-4">
                <h3 className="font-semibold text-slate-900">Collecte des données</h3>
                <p className="text-slate-700">
                  Les données personnelles collectées sur ce site (nom, prénom, email, téléphone, etc.) le sont uniquement 
                  dans le cadre de demandes de devis, de contact ou de réservation de services.
                </p>
                
                <h3 className="font-semibold text-slate-900">Utilisation des données</h3>
                <p className="text-slate-700">
                  Ces données sont utilisées exclusivement pour répondre à vos demandes et vous fournir nos services. 
                  Elles ne sont jamais transmises à des tiers sans votre consentement explicite.
                </p>
                
                <h3 className="font-semibold text-slate-900">Vos droits</h3>
                <p className="text-slate-700">
                  Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, 
                  de rectification, de portabilité et d'effacement de vos données. Vous pouvez également vous opposer au traitement 
                  de vos données ou demander la limitation du traitement.
                </p>
                
                <h3 className="font-semibold text-slate-900">Contact</h3>
                <p className="text-slate-700">
                  Pour exercer ces droits ou pour toute question relative à la protection de vos données personnelles, 
                  contactez-nous à : <a href="mailto:laudare.iledere@gmail.com" className="text-primary hover:text-primary/80">laudare.iledere@gmail.com</a>
                </p>
              </div>
            </div>
          </ScrollReveal>

          {/* 7. Cookies */}
          <ScrollReveal>
            <div className="mb-12">
              <div className="flex items-center mb-6">
                <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                  <Cookie className="h-5 w-5 text-primary" />
                </div>
                <h2 className="text-2xl font-bold text-slate-900">
                  7. Utilisation des cookies
                </h2>
              </div>
              
              <div className="bg-slate-50 rounded-lg p-6 space-y-4">
                <p className="text-slate-700">
                  Ce site utilise des cookies techniques nécessaires au bon fonctionnement du site et à l'amélioration de l'expérience utilisateur.
                </p>
                <p className="text-slate-700">
                  Les cookies techniques permettent notamment de mémoriser vos préférences de navigation et d'assurer la sécurité de votre connexion.
                </p>
                <p className="text-slate-700">
                  Vous pouvez configurer votre navigateur pour refuser les cookies, mais cela peut affecter le bon fonctionnement du site.
                </p>
              </div>
            </div>
          </ScrollReveal>

          {/* 8. Médiation de la consommation */}
          <ScrollReveal>
            <div className="mb-12">
              <div className="flex items-center mb-6">
                <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                  <Scale className="h-5 w-5 text-primary" />
                </div>
                <h2 className="text-2xl font-bold text-slate-900">
                  8. Médiation de la consommation
                </h2>
              </div>
              
              <div className="bg-slate-50 rounded-lg p-6">
                <p className="text-slate-700">
                  Conformément à l'article L. 616-1 du Code de la consommation, nous informons le consommateur qu'il peut recourir 
                  à une médiation de la consommation en cas de litige. Les coordonnées du médiateur compétent seront communiquées 
                  sur demande ou en cas de litige non résolu.
                </p>
              </div>
            </div>
          </ScrollReveal>

          {/* 9. Droit applicable */}
          <ScrollReveal>
            <div className="mb-12">
              <div className="flex items-center mb-6">
                <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                  <Scale className="h-5 w-5 text-primary" />
                </div>
                <h2 className="text-2xl font-bold text-slate-900">
                  9. Droit applicable et juridiction compétente
                </h2>
              </div>
              
              <div className="bg-slate-50 rounded-lg p-6">
                <p className="text-slate-700">
                  Tout litige en relation avec l'utilisation du site <strong>Les Hirondelles</strong> est soumis au droit français. 
                  Il est fait attribution exclusive de juridiction aux tribunaux compétents de La Rochelle.
                </p>
              </div>
            </div>
          </ScrollReveal>

          {/* Contact */}
          <ScrollReveal>
            <div className="bg-primary/5 rounded-lg p-8 text-center">
              <h3 className="text-xl font-bold text-slate-900 mb-4">
                Une question sur nos mentions légales ?
              </h3>
              <p className="text-slate-700 mb-6">
                Notre équipe est à votre disposition pour toute question juridique ou administrative.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <div className="flex items-center justify-center">
                  <Phone className="h-4 w-4 text-primary mr-2" />
                  <span className="text-slate-700 font-medium">07 66 47 77 46</span>
                </div>
                <div className="flex items-center justify-center">
                  <Mail className="h-4 w-4 text-primary mr-2" />
                  <a href="mailto:laudare.iledere@gmail.com" className="text-primary hover:text-primary/80 font-medium">
                    laudare.iledere@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </ScrollReveal>

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MentionsLegales;